import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import styles from './TradeRecommendationForm.module.css';
import Input from '../../common/Input/Input';
import Button from '../../common/Button/Button';
import SearchSelect from '../../common/SearchSelect/SearchSelect';
import Textarea from '../../common/textArea/TextArea';
import Select from '../../common/Select/Select';
import { VALIDATION_MESSAGES } from '../../../utils/constants';
import { API_ENDPOINTS } from '../../../utils/constants';
import api from '../../../services/api';
import { ToastContainer, toast } from "react-toastify";



const TradeRecommendationForm = ({
  tradeRecommendation,
  onSubmit,
  onCancel,

  fullscreenMode = false,
  onFormDataChange,
  targetStatusOptions: targetStatusOptionsProp = [],
}) => {
  const formatStockLabel = (t) => {
    if (!t) return "";
    return `${t.name} (${t.symbol}) [${t.token}] - ${t.exch_seg || ""}`;
  };

  const [isEditing, setIsEditing] = useState(!!tradeRecommendation);
  const [tradeTypeIdOptions, setTradeTypeIdOptions] = useState([]);
  const [scriptIdOptions, setScriptIdOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [scriptTypeOptions, setScriptTypeOptions] = useState([]);
  const [internalTokens, setInternalTokens] = useState([]);
  const [scriptSearchTerm, setScriptSearchTerm] = useState("");

  const now = new Date();
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");

  const [searchTerm, setSearchTerm] = useState("");

  const filteredOptions = scriptIdOptions.filter(opt =>
    opt.label.toLowerCase().includes(searchTerm.toLowerCase())
  );
  const [initialStopLoss, setInitialStopLoss] = useState(null);
  const [initialTargetOne, setInitialTargetOne] = useState(null);
  const [initialExitType, setInitialExitType] = useState(null);
  const [initialTargetOneStatus, setInitialTargetOneStatus] = useState(null);


  const {
    register,
    handleSubmit,
    formState: { errors, isDirty },
    reset,
    watch,
    setValue,
  } = useForm({
    defaultValues: {
      tradeRecommendationId: tradeRecommendation?.tradeRecommendationId || '',
      tradeTypeId: tradeRecommendation?.tradeTypeId || '',
      script: tradeRecommendation?.script || '',
      token: tradeRecommendation?.token || '',
      scriptTypeId: tradeRecommendation?.scriptTypeId || '',
      recoDate: tradeRecommendation?.recoDate || new Date().toISOString().split("T")[0],
      recoTime: tradeRecommendation?.recoTime || `${hours}:${minutes}`,
      recoExitDate: tradeRecommendation?.recoExitDate || '',
      recoPriceLow: tradeRecommendation?.recoPriceLow || '',
      recoPriceHigh: tradeRecommendation?.recoPriceHigh || '',
      targetOne: tradeRecommendation?.targetOne || '',
      targetTwo: tradeRecommendation?.targetTwo || '',
      targetThree: tradeRecommendation?.targetThree || '',
      targetOneStatus: tradeRecommendation?.targetOneStatus || '',
      targetTwoStatus: tradeRecommendation?.targetTwoStatus || '',
      targetThreeStatus: tradeRecommendation?.targetThreeStatus || '',
      stopLoss: tradeRecommendation?.stopLoss || '',
      status: tradeRecommendation?.status || '',
      exitTypeId: String(tradeRecommendation?.exitTypeId) || '',
      exitDate: tradeRecommendation?.exitDate || null,
      exitTime: tradeRecommendation?.exitTime || null,
      exitPriceLow: tradeRecommendation?.exitPriceLow || '',
      exitPriceHigh: tradeRecommendation?.exitPriceHigh || '',
      entryNote: tradeRecommendation?.entryNote || '',
      exitNote: tradeRecommendation?.exitNote ?? tradeRecommendation?.exitnote ??
        '',
      track_only: tradeRecommendation?.track_only || false,
    },
  });

  const watchStockId = watch("stockId");
  const watchRecommendationType = watch("recommendationType");
  const watchTargetPrice = watch("targetPrice");
  const watchStopLoss = watch("stopLoss");
  const watchTimeframe = watch("timeframe");
  const watchExitTypeId = String(watch("exitTypeId") || "");
  const watchScript = watch("script");
  const watchStatus = watch("status");

  const isLiveStatus = String(watchStatus || "").toLowerCase() === "live";

  const selectedToken = internalTokens.find(
    (token) =>
      String(token.symbol) === String(watchScript) ||
      String(token.token) === String(watchScript),
  );



  useEffect(() => {
    if (onFormDataChange) {
      onFormDataChange({
        stockId: watchStockId || '',
        recommendationType: watchRecommendationType || '',
        targetPrice: watchTargetPrice || '',
        stopLoss: watchStopLoss || '',
        timeframe: watchTimeframe || ''
      });
    }
  }, [watchStockId, watchRecommendationType, watchTargetPrice, watchStopLoss, watchTimeframe, onFormDataChange]);

  useEffect(() => {
    if (tradeRecommendation &&
      tradeTypeIdOptions.length > 0 &&
      scriptTypeOptions.length > 0 &&
      tradeTypeIdOptions.length > 0) {
      reset({
        tradeRecommendationId: tradeRecommendation.tradeRecommendationId || '',
        tradeTypeId: String(tradeRecommendation.tradeTypeId) || '',
        script: tradeRecommendation.script || '',
        token: tradeRecommendation.token || '',
        scriptTypeId: tradeRecommendation.scriptTypeId || '',
        recoDate: tradeRecommendation.recoDate || '',
        recoTime: tradeRecommendation.recoTime || '',
        recoExitDate: tradeRecommendation.recoExitDate || '',
        recoPriceLow: tradeRecommendation.recoPriceLow || '',
        recoPriceHigh: tradeRecommendation.recoPriceHigh || '',
        targetOne: tradeRecommendation.targetOne || '',
        targetTwo: tradeRecommendation.targetTwo || '',
        targetThree: tradeRecommendation.targetThree || '',
        targetOneStatus: tradeRecommendation.targetOneStatus || '',
        targetTwoStatus: tradeRecommendation.targetTwoStatus || '',
        targetThreeStatus: tradeRecommendation.targetThreeStatus || '',
        stopLoss: tradeRecommendation.stopLoss || '',
        status: tradeRecommendation.status || '',
        exitTypeId: String(tradeRecommendation.exitTypeId) || '',
        exitDate: tradeRecommendation.exitDate || '',
        exitTime: tradeRecommendation.exitTime || '',
        exitPriceLow: tradeRecommendation.exitPriceLow || '',
        exitPriceHigh: tradeRecommendation.exitPriceHigh || '',
        entryNote: tradeRecommendation.entryNote || '',
        // exitNote: tradeRecommendation.exitNote || '',
        exitNote: tradeRecommendation?.exitNote ?? tradeRecommendation?.exitnote ??
          '',

        recommendationType: tradeRecommendation.recommendationType || tradeRecommendation.recommendationtype || 'Buy',
        entryPrice: tradeRecommendation.entryPrice || tradeRecommendation.entryprice || '',
        targetPrice: tradeRecommendation.targetPrice || tradeRecommendation.targetprice || '',
        track_only: tradeRecommendation.track_only || false,
      });
      setIsEditing(true);
    }
  }, [tradeRecommendation, tradeTypeIdOptions, scriptTypeOptions, reset]);

  // Effect to set initial search term when internalTokens loads and we have a script value
  useEffect(() => {
    if (tradeRecommendation?.script && internalTokens.length > 0) {

      const tokenObj = internalTokens.find(
        (t) =>
          String(t.symbol) === String(tradeRecommendation.script) ||
          String(t.token) === String(tradeRecommendation.token)
      );

      if (tokenObj) {
        setScriptSearchTerm(formatStockLabel(tokenObj));

        setValue("script", tokenObj.symbol);
        setValue("token", tokenObj.token);
      } else {
        setScriptSearchTerm(String(tradeRecommendation.script));
        setValue("token", tradeRecommendation.token || "");
      }
    }
  }, [tradeRecommendation, internalTokens]);

  const fetchTradeTypes = async () => {
    try {
      const res = await api.get(`${API_ENDPOINTS.TRADE_TYPE}`);
      const formattedOptions = res.data.map(item => ({
        value: String(item.tradeTypeId),
        label: item.tradeTypeName
      }));

      setTradeTypeIdOptions(formattedOptions);
    } catch (error) {
      console.log("Error fetching trade type id", error);
    }
  };

  // console.log(`initialTargetOneStatus ${initialTargetOneStatus}`);

  const fetchduration = (id) => {
    const selectedType = tradeTypeIdOptions.find(
      (option) => String(option.value) === String(id),
    );
    return selectedType?.label || "";
  };


  const fetchScript = async () => {
    try {
      // Using internaltoken/list to match CommunityMaster behavior
      const res = await api.get('/internaltoken/list');
      if (res.status && res.data) {
        setInternalTokens(res.data);
        // We don't need scriptIdOptions anymore for this field, but keeping logic clean
      }
    } catch (error) {
      console.log("Error fetching tokens", error);
    }
  };

  const fetchScriptType = async () => {
    try {
      const res = await api.get(`${API_ENDPOINTS.SCRIPT_TYPE}`);
      const formattedOptions = res.data.map((item) => ({
        id: item.scriptTypeId,
        value: item.scriptTypeId,
        label: item.scriptTypeName,
      }));

      setScriptTypeOptions(formattedOptions);
    } catch (error) {
      console.log("Error fetching script type", error);
    }
  };

  const watchExitTime = watch("exitTime");
  const watchExitDate = watch("exitDate");
  const watchExitPriceLow = watch("exitPriceLow");
  const watchTargetOne = watch("targetOne");
  const isTargetHit = String(watchStatus || "").toLowerCase() === "target hit";
  const isClosed = String(watchStatus || "").toLowerCase() === "Closed";
  const recopriceLowdata = watch("recopriceLow");

  useEffect(() => {
    if (!isLiveStatus) {
      if (!watchExitDate) {
        setValue("exitDate", new Date().toISOString().split("T")[0], {
          shouldDirty: true,
          shouldValidate: true,
        });
      }
      if (!watchExitTime) {
        const now = new Date();
        const hh = String(now.getHours()).padStart(2, "0");
        const mm = String(now.getMinutes()).padStart(2, "0");
        setValue("exitTime", `${hh}:${mm}`, {
          shouldDirty: true,
          shouldValidate: true,
        });
      }
      if (!watchExitPriceLow) {
        if (isTargetHit && watchTargetOne) {
          setValue("exitPriceLow", watchTargetOne, {
            shouldDirty: true,
            shouldValidate: true,
          });
          setValue("exitTypeId", "1", {
            shouldDirty: true,
            shouldValidate: true,
          });
        } else if (watchStopLoss) {
          setValue("exitPriceLow", watchStopLoss, {
            shouldDirty: true,
            shouldValidate: true,
          });
          setValue("exitTypeId", "1", {
            shouldDirty: true,
            shouldValidate: true,
          });
        }
        else if (isClosed) {
          setValue("exitPriceLow", null, {
            shouldDirty: false,
            shouldValidate: false,
          });
          setValue("exitTypeId", "1", {
            shouldDirty: true,
            shouldValidate: true,
          });
        }
      }





    }
  }, [isLiveStatus, watchExitDate, watchExitTime, setValue, watchTargetOne, watchStopLoss, isClosed, recopriceLowdata]);

  useEffect(() => {
    fetchScript();
    fetchTradeTypes();
    fetchScriptType();
  }, []);

  const onFormSubmit = async (data) => {
    if (onSubmit) {
      const formattedData = {
        ...data,

        recoPriceLow: parseFloat(data.recoPriceLow) || 0,
        recoPriceHigh: parseFloat(data.recoPriceHigh) || 0,
        targetOne: parseFloat(data.targetOne) || 0,
        targetTwo: parseFloat(data.targetTwo) || 0,
        targetThree: parseFloat(data.targetThree) || 0,
        stopLoss: parseFloat(data.stopLoss) || 0,
        track_only: !!data.track_only,
        ...(isEditing && {
          tradeRecommendationId: tradeRecommendation?.traderecommendationid || tradeRecommendation?.tradeRecommendationId
        }),
      };

      let submitSucceeded = false;
      let stopLossChanged = false;
      let targetUpdated = false;
      let manualExitTriggered = false;
      let profitPercent = 0;
      let script = "";
      let targetHitTriggered = false;
      let stopLossHitTriggered = false;
      let duration = "";
      let scriptTypeId = 0;
      let side = 0;
      let actualProfit = 0;
      let isClosed;
      let actualProfitpercentage = 0;


      try {
        setLoading(true);
        const response = await onSubmit(formattedData);

        submitSucceeded = true;
        stopLossChanged =
          isEditing &&
          initialStopLoss !== null &&
          Number(initialStopLoss) !== Number(formattedData.stopLoss);
        targetUpdated =
          isEditing &&
          initialTargetOne !== null &&
          Number(initialTargetOne) !== Number(formattedData.targetOne);


        isClosed =
          String(formattedData.status || "").toLowerCase() === "closed";

        if (isClosed && !formattedData.exitTypeId) {
          setValue("exitTypeId", "1", { shouldDirty: true, shouldValidate: true });
        }
        manualExitTriggered =
          isEditing &&
          isClosed &&
          String(initialExitType || "") !== "1";



        // profit % calculate
        profitPercent = formattedData.recoPriceLow
          ? (
            ((formattedData.targetOne - formattedData.recoPriceLow) /
              formattedData.recoPriceLow) *
            100
          ).toFixed(2)
          : 0;
        script = formattedData.script;

        targetHitTriggered =
          isEditing &&
          String(formattedData.status || "").toLowerCase() === "target hit" &&
          String(initialTargetOneStatus || "").toLowerCase() !== "target hit";

        if (formattedData.status === "Target Hit" && !formattedData.targetOneStatus) {
          setValue("targetOneStatus", "Target Hit", { shouldDirty: true });
        }

        if (formattedData.status === "Stoploss Hit" && !formattedData.targetThreeStatus) {
          setValue("targetThreeStatus", "Stoploss Hit", { shouldDirty: true });
        }

        // Safer stoploss trigger based on status

        stopLossHitTriggered =
          isEditing &&
          (String(formattedData.status || "").toLowerCase() === "stoploss hit" ||
            String(formattedData.status || "").toLowerCase() === "stop loss hit") &&
          String(initialTargetOneStatus || "").toLowerCase() !== "stoploss hit";


        duration =
          formattedData.recoDate && formattedData.exitDate
            ? `${Math.ceil(
              (new Date(formattedData.exitDate) -
                new Date(formattedData.recoDate)) /
              (1000 * 60 * 60 * 24),
            )} Days`
            : "";

        scriptTypeId = Number(formattedData.scriptTypeId);
        side = Number(formattedData.tradeRecommendationId);
      } catch (error) {
        console.error("Submit failed", error);
      } finally {
        if (side === 1) {
          actualProfit = Number(formattedData.targetOne) - Number(formattedData.recoPriceLow);
          actualProfitpercentage =
            ((Number(formattedData.targetOne) - Number(formattedData.recoPriceLow)) /
              Number(formattedData.recoPriceLow)) *
            100;
        } else if (side === 2) {
          actualProfit = Number(formattedData.recoPriceLow) - Number(formattedData.targetOne);
          actualProfitpercentage =
            ((Number(formattedData.recoPriceLow) - Number(formattedData.targetOne)) /
              Number(formattedData.recoPriceLow)) *
            100;
        }

        setLoading(false);
      }

      if (submitSucceeded && !formattedData.track_only) {
        // ======================
        // NEW RECOMMENDATION
        // ======================
        if (!isEditing) {
          // id notification id,
          // notification title,
          // notification message,
          // query Target  with notification query id
          // notificationtypeid 1 for stock call

          //Paid Equity trade
          if (scriptTypeId === 1) {
            handleSendNotification(
              1,
              "Equity Trade Idea",
              `${formattedData.tradeRecommendationId == 1 ? "Buy" : formattedData.tradeRecommendationId == 2 ? "Sell" : null} ${script} with ${profitPercent}% Profit Potential for ${fetchduration(formattedData.tradeTypeId)}, check more details in the application.`,
              12,
              1,
              scriptTypeId,
            );

            // Non Paid Equity trade
            handleSendNotification(
              1,
              "Equity Trade Idea",
              `${formattedData.tradeRecommendationId == 1 ? "Buy" : formattedData.tradeRecommendationId == 2 ? "Sell" : null} trade posted with ${profitPercent}% Profit Potential for ${fetchduration(formattedData.tradeTypeId)}, check more details in the application.`,
              16,
              1,
              scriptTypeId,
            );
            //Paid Futures trade
          } else if (scriptTypeId === 2) {
            handleSendNotification(
              1,
              "Futures Trade Idea",
              `${formattedData.tradeRecommendationId == 1 ? "Buy" : formattedData.tradeRecommendationId == 2 ? "Sell" : null} ${script} with ${profitPercent}% Profit Potential for ${fetchduration(formattedData.tradeTypeId)}, check more details in the application.`,
              14,
              1,
              scriptTypeId,
            );
            // Non Paid Futures trade
            handleSendNotification(
              1,
              "Futures Trade Idea",
              `${formattedData.tradeRecommendationId == 1 ? "Buy" : formattedData.tradeRecommendationId == 2 ? "Sell" : null} trade posted with ${profitPercent}% Profit Potential for ${fetchduration(formattedData.tradeTypeId)}, check more details in the application.`,
              17,
              1,
              scriptTypeId,
            );
          }  //Paid Options trade
          else if (scriptTypeId === 3) {
            handleSendNotification(
              1,
              "Options Trade Idea",
              `${formattedData.tradeRecommendationId == 1 ? "Buy" : formattedData.tradeRecommendationId == 2 ? "Sell" : null} ${script} with ${profitPercent}% Profit Potential for ${fetchduration(formattedData.tradeTypeId)}, check more details in the application.`,
              13,
              1,
              scriptTypeId,
            );
            // Non Paid Options trade
            handleSendNotification(
              1,
              "Options Trade Idea",
              `${formattedData.tradeRecommendationId == 1 ? "Buy" : formattedData.tradeRecommendationId == 2 ? "Sell" : null} trade posted with ${profitPercent}% Profit Potential for ${fetchduration(formattedData.tradeTypeId)}, check more details in the application.`,
              18,
              1,
              scriptTypeId,
            );
          }

        }

        // ======================
        // STOP LOSS UPDATED
        // ======================

        //All Paid equity Users
        if (stopLossChanged && (scriptTypeId === 1)) {
          handleSendNotification(
            3,
            "SL Updated for Equity Trade",
            `Stop Loss updated for ${formattedData.script} from ${Number(initialStopLoss).toFixed(2)} to ${Number(formattedData.stopLoss).toFixed(2)}. Please update your trade if taken. Check more details in the application.`,
            12,
            1,
            scriptTypeId,
          );
        }
        //All Paid Futures Users
        else if (stopLossChanged && (scriptTypeId === 2)) {
          handleSendNotification(
            3,
            "SL Updated for Futures Trade",
            `Stop Loss updated for ${formattedData.script} from ${Number(initialStopLoss).toFixed(2)} to ${Number(formattedData.stopLoss).toFixed(2)}. Please update your trade if taken. Check more details in the application.`,
            14,
            1,
            scriptTypeId,
          );
        }
        // All Paid Options Users
        else if (stopLossChanged && (scriptTypeId === 3)) {
          handleSendNotification(
            3,
            "SL Updated for Options Trade",
            `Stop Loss updated for ${formattedData.script} from ${Number(initialStopLoss).toFixed(2)} to ${Number(formattedData.stopLoss).toFixed(2)}. Please update your trade if taken. Check more details in the application.`,
            13,
            1,
            scriptTypeId,
          );
        }

        // ======================
        // TARGET PRICE INCREASED
        // ======================
        // All Paid Equity Users
        if (targetUpdated && (scriptTypeId === 1)) {
          handleSendNotification(
            1,
            `Target Updated for Equity Trade`,
            `Target price updated for ${formattedData.script} from ${(initialTargetOne)} to ${(formattedData.targetOne)}. Update your trade if taken. Check more details in the application.`,
            12,
            1,
          );// All Free Equity Users
          handleSendNotification(
            1,
            "Target Updated for Equity Trade",
            `Target price updated by ${Math.abs(((formattedData.targetOne - initialTargetOne) / initialTargetOne) * 100).toFixed(2)}%.  Don't miss opportunities, subscribe now to get more details.`,
            16,
            1,
            scriptTypeId,
          );
        }
        // All Paid Future Users
        else if (targetUpdated && (scriptTypeId === 2)) {
          handleSendNotification(
            2,
            `Target Updated for Futures Trade`,
            `Target price updated for ${formattedData.script} from ${(initialTargetOne)} to ${(formattedData.targetOne)}. Update your trade if taken. Check more details in the application.`,
            14,
            1,
          );

          // All Free Future Users
          handleSendNotification(
            1,
            "Target Updated for Futures Trade",
            `Target price updated by ${Math.abs(((formattedData.targetOne - initialTargetOne) / initialTargetOne) * 100).toFixed(2)}%.  Don't miss opportunities, subscribe now to get more details.`,
            17,
            1,
            scriptTypeId,
          );
        }
        // All Paid Options Users
        else if (targetUpdated && (scriptTypeId === 3)) {
          handleSendNotification(
            2,
            `Target Updated for Options Trade`,
            `Target price updated for ${formattedData.script} from ${(initialTargetOne)} to ${(formattedData.targetOne)}. Update your trade if taken. Check more details in the application.`,
            13,
            1,
          );

          // ALL Free Options Users
          handleSendNotification(
            1,
            "Target Updated for Options Trade",
            `Target price updated by ${Math.abs(((formattedData.targetOne - initialTargetOne) / initialTargetOne) * 100).toFixed(2)}%. Don't miss opportunities, subscribe now to get more details.`,
            18,
            1,
            scriptTypeId,
          );
        }


        // ======================
        // TARGET HIT
        // ======================

        // for Equity Paid Users
        if (targetHitTriggered && (scriptTypeId === 1)) {
          handleSendNotification(
            1,
            "Target Hit for Equity Trade",
            `Target hit 🔥 for ${formattedData.script} book profit of ₹${actualProfit.toFixed(2)} (${actualProfitpercentage.toFixed(2)}%) in ${fetchduration(formattedData.tradeTypeId)}. Check more details in the application.`,
            12,
            1,
            scriptTypeId,
          );
          // for Equity free Users
          handleSendNotification(
            1,
            "Target Hit",
            `Target hit for ${formattedData.script} premium users booked profit of ₹${actualProfit.toFixed(2)} in ${fetchduration(formattedData.tradeTypeId)}. Don't miss opportunities, subscribe now!.`,
            16,
            1,
            scriptTypeId,
          );

        }   // for futures Paid Users
        else
          if (targetHitTriggered && (scriptTypeId === 2)) {
            handleSendNotification(
              1,
              "Target Hit for Futures Trade",
              `Target hit 🔥 for ${formattedData.script} book profit of ₹${actualProfit.toFixed(2)} (${actualProfitpercentage.toFixed(2)}%) in ${fetchduration(formattedData.tradeTypeId)}. Check more details in the application.`,
              14,
              1,
              scriptTypeId,
            );
            // for future free Users
            handleSendNotification(
              1,
              "Target Hit",
              `Target hit for ${formattedData.script} premium users booked profit of ₹${actualProfit.toFixed(2)} in ${fetchduration(formattedData.tradeTypeId)}. Don't miss opportunities, subscribe now!`,
              17,
              1,
              scriptTypeId,
            );
          }   // for Options Paid Users
          else
            if (targetHitTriggered && (scriptTypeId === 3)) {
              handleSendNotification(
                1,
                "Target Hit for Options Trade",
                `Target hit 🔥 for ${formattedData.script} book profit of ₹${actualProfit.toFixed(2)} (${actualProfitpercentage.toFixed(2)}%) in ${fetchduration(formattedData.tradeTypeId)}. Check more details in the application.`,
                13,
                1,
                scriptTypeId,
              );
              // for Futures free Users
              handleSendNotification(
                1,
                "Target Hit",
                `Target hit for ${formattedData.script} premium users booked profit of ₹${actualProfit.toFixed(2)} in  ${fetchduration(formattedData.tradeTypeId)}. Don't miss opportunities, subscribe now!`,
                18,
                1,
                scriptTypeId,
              );
            }



        // ======================
        // STOP LOSS HIT
        // ======================
        if (stopLossHitTriggered && (scriptTypeId === 1)) {
          // for Equity Paid Users
          handleSendNotification(
            2,
            "SL Hit for Equity Trade",
            `Stop loss hit for ${formattedData.script}. Exit your trade if taken. Check more details in the application.`,
            12,
            1,
            scriptTypeId,
          );
        }
        else if (stopLossHitTriggered && (scriptTypeId === 2)) {
          // for Futures Paid Users
          handleSendNotification(
            2,
            "SL Hit for for Futures Trade",
            `Stop loss hit for ${formattedData.script}. Exit your trade if taken. Check more details in the application.`,
            14,
            1,
            scriptTypeId,
          );
        }
        else if (stopLossHitTriggered && (scriptTypeId === 3)) {
          // for Options Paid Users
          handleSendNotification(
            2,
            "SL Hit for for Options Trade",
            `Stop loss hit for ${formattedData.script}. Exit your trade if taken. Check more details in the application.`,
            13,
            1,
            scriptTypeId,
          );
        }


        // ======================
        // MANUAL EXIT
        // ======================
        if (manualExitTriggered) {
          // Trade Closed for Equity Paid User
          handleSendNotification(
            2,
            "Trade Closed for Equity",
            `Take exit in ${formattedData.script} at ${formattedData.exitPriceLow} ${formattedData.exitNote}. Check more details in the application.`,
            12,
            1,
            scriptTypeId,
          );
        } else if (manualExitTriggered) {
          // Trade Closed for Futures Paid User
          handleSendNotification(
            2,
            "Trade Closed for Futures",
            `Take exit in ${formattedData.script} at ${formattedData.exitPriceLow} ${formattedData.exitNote}. Check more details in the application.`,
            14,
            1,
            scriptTypeId,
          );
        } else if (manualExitTriggered) {
          // Trade Closed for Options Paid User
          handleSendNotification(
            2,
            "Trade Closed for Options",
            `Take exit in ${formattedData.script} at ${formattedData.exitPriceLow} ${formattedData.exitNote}. Check more details in the application.`,
            13,
            1,
            scriptTypeId,
          );
        }

      }
    }
  };
  // =========================
  // SEND NOTIFICATION
  // =========================
  const handleSendNotification = async (
    id,
    title,
    message,
    query,
    notificationtypeid,
    scriptTypeId,
  ) => {
    if (!id) return;

    try {
      setLoading(true);

      const payload = {
        id,
        title,
        message,
        query,
        notificationtypeid,
        ...(scriptTypeId ? { scriptTypeId } : {}),
      };

      const response = await api.post("/notification/send", payload);

      console.log(`sent notification ${response}`);

      toast.success(
        response.data?.message ||
        `Notification sent successfully to ${response.sent} users!`,
      );
      return;
    } catch (error) {
      console.error("Failed to send notification:", error);
      toast.error("Failed to send notification");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (tradeRecommendation) {
      setInitialStopLoss(Number(tradeRecommendation.stopLoss));
    }
  }, [tradeRecommendation]);
  useEffect(() => {
    if (tradeRecommendation) {
      setInitialTargetOne(Number(tradeRecommendation.targetOne));
    }
  }, [tradeRecommendation]);
  useEffect(() => {
    if (tradeRecommendation) {
      setInitialExitType(Number(tradeRecommendation.exitTypeId));
    }
  }, [tradeRecommendation]);

  useEffect(() => {
    if (tradeRecommendation) {
      console.log(`status = ${tradeRecommendation.targetOneStatus}`)
      setInitialTargetOneStatus(tradeRecommendation.targetOneStatus);
    }
  }, [tradeRecommendation]);

  useEffect(() => {
    if (isLiveStatus) {
      setValue("exitTypeId", "");
      setValue("exitDate", null);
      setValue("exitTime", null);
      setValue("exitPriceLow", "");
      setValue("exitPriceHigh", "");
      setValue("exitNote", "");
    }
  }, [isLiveStatus, setValue]);

  const handleReset = () => {
    if (tradeRecommendation) {
      reset();
    } else {
      reset({
        stockId: "",
        stockSymbol: "",
        stockName: "",
        recommendationType: "Buy",
        entryPrice: "",
        targetPrice: "",
        stopLoss: "",
        timeframe: "",
        riskLevel: "Medium",
        status: "Active",
        rationale: "",
        technicalIndicators: "",
        fundamentalFactors: "",
      });
    }
  };

  const tradeRecommendationIdOptions = [
    { value: 1, label: "Buy" },
    { value: 2, label: "Sell" },
  ];

  const defaultTargetStatusOptions = [
    { value: "Target Hit", label: "Target Hit" },
    { value: "Live", label: "Live" },
    { value: "Stoploss Hit", label: "Stoploss Hit" },
    { value: "Closed", label: "Closed" },
  ];
  const targetStatusOptions =
    targetStatusOptionsProp.length > 0
      ? targetStatusOptionsProp
      : defaultTargetStatusOptions;

  const exitTypeIdOptions = [
    { value: 1, label: "Manual Exit" },
    { value: 2, label: "Auto Exit" },
  ];

  const formClasses = [styles.form, fullscreenMode ? "fullscreenModal" : ""]
    .filter(Boolean)
    .join(" ");

  const renderPriceFieldWithLtp = ({
    fieldName,
    label,
    placeholder,
    validation,
    error,
    required = false,
  }) => (
    <div className={styles.priceFieldWrapper}>
      <Input
        label={label}
        type="number"
        step="0.01"
        placeholder={placeholder}
        error={error}
        {...register(fieldName, validation)}
        required={required}
      />
      {/* <button
        type="button"
        className={styles.ltpButton}
        onClick={() => setFieldFromLtp(fieldName)}
        disabled={currentLtp == null || Number.isNaN(Number(currentLtp))}
        title={
          currentLtp == null
            ? "Select script and wait for live price"
            : `Use LTP ${Number(currentLtp).toFixed(2)}`
        }
      >
        {currentLtp ? "🟢" : "🔴"}
      </button> */}
    </div>
  );

  return (
    <div className={fullscreenMode ? "fullscreen-form-container" : ""}>
      <form className={formClasses} onSubmit={handleSubmit(onFormSubmit)}>
        {!fullscreenMode && (
          <div className={styles.formHeader}>
            <h2 className={styles.formTitle}>
              {isEditing
                ? "Edit Trade Recommendation"
                : "Create New Trade Recommendation"}
            </h2>
            <p className={styles.formSubtitle}>
              {isEditing
                ? "Update trade recommendation details below"
                : "Fill in the details to create a new trade recommendation"}
            </p>
          </div>
        )}

        <div
          className={`${styles.formGrid} ${styles.formGrid6Col}`}
        >
          {/* --- ROW 1 --- */}
          <div className={styles.formGroup}>
            <Select
              label="Category"
              required
              options={tradeRecommendationIdOptions}
              placeholder="Select recommendation"
              error={errors.tradeRecommendationId?.message}
              {...register("tradeRecommendationId", {
                required: VALIDATION_MESSAGES.REQUIRED,
              })}
            />
          </div>
          <div className={styles.formGroup}>
            <Input
              label="Entry Date"
              type="date"
              placeholder="Select recommendation date"
              error={errors.recoDate?.message}
              {...register("recoDate", {
                required: VALIDATION_MESSAGES.REQUIRED,
              })}
              required
            />
          </div>
          <div className={styles.formGroup}>
            <Input
              label="Time"
              type="time"
              placeholder="Select recommendation time"
              error={errors.recoTime?.message}
              {...register("recoTime", {
                required: VALIDATION_MESSAGES.REQUIRED,
              })}
              required
            />
          </div>
          <div className={styles.formGroup}>
            <Select
              label="Type"
              required
              options={tradeTypeIdOptions}
              placeholder="Select trade type"
              error={errors.tradeTypeId?.message}
              {...register("tradeTypeId", {
                required: VALIDATION_MESSAGES.REQUIRED,
              })}
            />
          </div>
          <div className={styles.formGroup}>
            <Input
              label="Reco Exit Date"
              type="date"
              placeholder="Select exit date"
              {...register("recoExitDate", {
                required: VALIDATION_MESSAGES.REQUIRED,
              })}
              required
            />
          </div>
          <div className={styles.formGroup}>
            <Select
              label="Status"
              options={targetStatusOptions}
              placeholder="Select status"
              error={errors.status?.message}
              {...register("status", {
                required: VALIDATION_MESSAGES.REQUIRED,
              })}
              required
            />
          </div>
          {/* --- ROW 2 --- */}
          <div className={styles.formGroup}>
            <label
              className={`${styles.label} ${styles.scriptLabel}`}
            >
              Script <span className={styles.requiredStar}>*</span>
            </label>
            <input
              type="text"
              list="scriptOptions"
              placeholder="Search script..."
              className={`${styles.input} ${errors.script ? styles.scriptInputError : styles.scriptInputNormal}`}
              value={scriptSearchTerm}
              onChange={(e) => {
                const val = e.target.value;
                setScriptSearchTerm(val);
                const tokenObj = internalTokens.find(
                  (t) =>
                    t.symbol === val ||
                    t.name === val ||
                    `${t.symbol} [${t.token}]` === val ||
                    `${t.symbol} (${t.name})` === val ||
                    formatStockLabel(t) === val,
                );
                if (tokenObj) {
                  setScriptSearchTerm(formatStockLabel(tokenObj));
                  setValue("script", tokenObj.symbol, { shouldValidate: true });
                  setValue("token", tokenObj.token, { shouldValidate: true });
                } else {
                  setValue("script", "", { shouldValidate: true });
                  setValue("token", "", { shouldValidate: true });
                }
              }}
            />
            <datalist id="scriptOptions">
              {internalTokens.map((token) => (
                <option
                  key={token.token}
                  value={formatStockLabel(token)}
                />
              ))}
            </datalist>
            {errors.script && (
              <span
                className={styles.fieldError}
              >
                {errors.script.message}
              </span>
            )}
            <input
              type="hidden"
              {...register("script", {
                required: VALIDATION_MESSAGES.REQUIRED,
              })}
            />
            <input
              type="hidden"
              {...register("token")}
            />
          </div>
          <div className={styles.formGroup}>
            <Select
              label="Script Type"
              options={scriptTypeOptions}
              placeholder="Select script type"
              error={errors.scriptTypeId?.message}
              {...register("scriptTypeId", {
                required: VALIDATION_MESSAGES.REQUIRED,
              })}
              required
            />
          </div>
          <div className={styles.formGroup}>
            {renderPriceFieldWithLtp({
              fieldName: "recoPriceLow",
              label: "Entry Price",
              placeholder: "Enter low price",
              validation: {
                required: VALIDATION_MESSAGES.REQUIRED,
                min: { value: 0, message: "Price must be >= 0" },
              },
              error: errors.recoPriceLow?.message,
              required: true,
            })}
          </div>
          <div className={styles.formGroup}>
            {renderPriceFieldWithLtp({
              fieldName: "targetOne",
              label: "Target 1",
              placeholder: "Enter target 1",
              validation: {
                required: VALIDATION_MESSAGES.REQUIRED,
                min: { value: 0.01, message: "Target must be > 0" },
              },
              error: errors.targetOne?.message,
              required: true,
            })}
          </div>
          <div className={styles.formGroup}>
            {renderPriceFieldWithLtp({
              fieldName: "stopLoss",
              label: "Stop Loss",
              placeholder: "Enter stop loss",
              validation: { required: VALIDATION_MESSAGES.REQUIRED },
              error: errors.stopLoss?.message,
              required: true,
            })}
          </div>
          <div
            className={`${styles.formGroup} ${styles.formGroupSpan3}`}
          >
            <Textarea
              label="Entry Note"
              placeholder="Enter entry notes"
              error={errors.entryNote?.message}
              {...register("entryNote", {
                required: VALIDATION_MESSAGES.REQUIRED,
                maxLength: { value: 1000 },
              })}
              required
              className={styles.textareaFull}
            />
          </div>
          {/* --- ROW 3 --- */}
          <div /> {/* blank */}
          <div /> {/* blank */}
          <div className={styles.formGroup}>
            <Input
              label="Reco Price High"
              type="number"
              step="0.01"
              placeholder="Enter high price"
              error={errors.recoPriceHigh?.message}
              {...register("recoPriceHigh", {
                min: { value: 0, message: "Price must be >= 0" },
              })}
            />
          </div>
          <div className={styles.formGroup}>
            <Input
              label="Target 2"
              type="number"
              step="0.01"
              placeholder="Enter target 2"
              error={errors.targetTwo?.message}
              {...register("targetTwo")}
            />
          </div>
          <div /> {/* STOP LOSS spacer */}
          {/* Entry Note spans here */}
          {/* --- ROW 4 --- */}
          <div /> {/* blank */}
          <div /> {/* blank */}
          <div /> {/* Reco high spacer */}
          <div className={styles.formGroup}>
            <Textarea
              label="Exit Note"
              placeholder="Enter exit notes"
              error={errors.exitNote?.message}
              {...register("exitNote", {
                maxLength: { value: 2000 },
              })}


              className={styles.textareaExitNote}
            />
          </div>
          <div /> {/* blank */}
          {/* Entry Note spans here */}
          {/* --- ROW 5 --- */}
          <div className={styles.formGroup}>
            <Select
              label="Exit Type"
              options={exitTypeIdOptions}
              placeholder="Select exit type"
              error={errors.exitTypeId?.message}
              {...register("exitTypeId", {
                required: !isLiveStatus && watchStatus ? VALIDATION_MESSAGES.REQUIRED : false,
              })}
              disabled={isLiveStatus}
            />
          </div>
          <div className={styles.formGroup}>
            <Input
              label="Exit Price Low"
              type="number"
              step="0.01"
              placeholder="Enter exit low price"
              error={errors.exitPriceLow?.message}
              {...register("exitPriceLow", {
                required: !isLiveStatus && watchStatus ? VALIDATION_MESSAGES.REQUIRED : false,
              })}
              disabled={isLiveStatus}
            />
          </div>
          <div className={styles.formGroup}>
            <Input
              label="Actual Exit Date"
              type="date"
              placeholder="Select exit date"
              {...register("exitDate", {
                required: !isLiveStatus && watchStatus ? VALIDATION_MESSAGES.REQUIRED : false,
              })}
              disabled={isLiveStatus}
            />
          </div>
          <div className={styles.formGroup}>
            <Input
              label="Actual Exit Time"
              type="time"
              placeholder="Select exit time"
              error={errors.exitTime?.message}
              {...register("exitTime", {
                required: !isLiveStatus && watchStatus ? VALIDATION_MESSAGES.REQUIRED : false,
              })}
              disabled={isLiveStatus}
            />
          </div>

          <div className={styles.formGroup}>
            <Input
              label="Attachment / File"
              type="file"
              accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
              error={errors.attachment?.message}
              {...register("attachment")}
            />
          </div>
          {/* --- ROW 6 --- */}
          <div /> {/* blank */}
          <div className={styles.formGroup}>
            <Input
              label="Exit Price High"
              type="number"
              step="0.01"
              placeholder="Enter exit high price"
              error={errors.exitPriceHigh?.message}
              {...register("exitPriceHigh")}
            />
          </div>
          <div /> {/* blank */}
          <div /> {/* blank */}
          {/* Exit Note spans here */}
          <div /> {/* blank */}
          {/* --- EXTRA FIELDS NOT IN IMAGE BUT REQUIRED --- */}
          <div
            className={styles.extraFieldsRow}
          >
            <div className={styles.flexOne}>
              <Select
                label="Target 1 Status"
                options={targetStatusOptions}
                placeholder="Select target 1 status"
                error={errors.targetOneStatus?.message}
                {...register("targetOneStatus")}
              />
            </div>
            <div className={styles.flexOne}>
              <Select
                label="Target 2 Status"
                options={targetStatusOptions}
                placeholder="Select target 2 status"
                error={errors.targetTwoStatus?.message}
                {...register("targetTwoStatus")}
              />
            </div>
            <div className={styles.flexOne}>
              <Select
                label="Target 3 Status"
                options={targetStatusOptions}
                placeholder="Select target 3 status"
                error={errors.targetThreeStatus?.message}
                {...register("targetThreeStatus")}
              />
            </div>
          </div>
        </div>

        {!fullscreenMode && (
          <div className={styles.formActions}>
            <Button
              type="button"
              variant="secondary"
              onClick={handleReset}
              disabled={loading}
            >
              Reset
            </Button>

            <Input
              label="Track Only"
              type="checkbox"
              {...register("track_only"
              )}
            // required
            />
            <Button
              type="button"
              variant="outline"
              onClick={onCancel}
              disabled={loading}
            >
              Cancel
            </Button>

            <Button
              type="submit"
              variant="primary"
              loading={loading}
              disabled={loading || (!isDirty && isEditing)}
            >
              {isEditing ? "Update Recommendation" : "Create Recommendation"}
            </Button>
          </div>
        )}

        {isEditing && !isDirty && !fullscreenMode && (
          <div className={styles.noChangesMessage}>
            <span>💡 Make changes to enable the update button</span>
          </div>
        )}
      </form>

      {fullscreenMode && (
        <div
          className={`modal-footer-actions ${styles.modalFooterActions}`}
        >

          <Input
            className={styles.checkboxMarginRight}
            type="checkbox"
            label="Track Only"
            {...register("track_only"
            )}
          // required
          />
          <Button
            type="button"
            variant="outline"
            onClick={onCancel}
            disabled={loading}
          >
            Cancel
          </Button>

          <Button
            type="submit"
            variant="primary"
            loading={loading}
            disabled={loading || (!isDirty && isEditing)}
            onClick={handleSubmit(onFormSubmit)}
          >
            {loading
              ? "Saving..."
              : isEditing
                ? "Update Recommendation"
                : "Create Recommendation"}
          </Button>
        </div>
      )}
    </div>
  );
};

export default TradeRecommendationForm;
